import * as React from "react";
import { useRouter } from "next/router";
import { useOffer } from "@nju/data-access-portal-offers";
import { useOrchestrators } from "@nju/data-access-portal-orchestrator";
import { OnboardingMembersInfo } from "@nju/feature-portal-msisdn";
import { SidebarOffer } from "@nju/feature-portal-sidebar";
import {
  BlockText,
  Button,
  Heading,
  Layout,
  Main,
  Separator,
  Side,
} from "@nju/ui";

export function CheckMigrationPossibilityPage() {
  const { reload } = useRouter();
  const multiOrderOrchestrator = useOrchestrators("multiOrder");

  const offer = useOffer(multiOrderOrchestrator?.offerId);

  const handleReloadPage = React.useCallback(() => {
    reload();
  }, [reload]);

  if (!multiOrderOrchestrator) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <>
      <OnboardingMembersInfo
        isMulti={false}
        multiOrder={multiOrderOrchestrator}
      />
      <Layout>
        <Main>
          <Heading
            className="font-bold mb-2 from-tablet:mb-6 max-w-[500px]"
            font="ttfirs"
            tone="neutral"
            variant="h2"
          >
            sprawdzamy, czy możesz przenieść numer
          </Heading>
          <BlockText>Potrzebujemy jeszcze chwili.</BlockText>
          <BlockText>
            Potwierdzamy możliwość przeniesienia Twojego numeru do nju
            subskrypcja.
          </BlockText>
          <Separator size="xl" />
          <div className="flex justify-start align-end">
            <Button
              display={{ "@onlyMobile": "block" }}
              onPress={handleReloadPage}
              size={{ "@onlyMobile": "s" }}
              type="submit"
            >
              odśwież
            </Button>
          </div>
        </Main>
        <Side>
          <SidebarOffer offer={offer} orchestrator={multiOrderOrchestrator} />
        </Side>
      </Layout>
    </>
  );
}
